import { CSSProperties, ReactNode } from "react";

interface ChipProps {
  children: ReactNode;
  filled?: boolean;
  style?: CSSProperties;
}

export function Chip({ children, filled, style }: ChipProps) {
  return (
    <span
      style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 10,
        letterSpacing: "0.1em",
        textTransform: "uppercase",
        padding: "3px 7px",
        border: "1px solid hsl(var(--ink))",
        background: filled ? "hsl(var(--ink))" : "transparent",
        color: filled ? "hsl(var(--cream))" : "hsl(var(--ink))",
        display: "inline-block",
        ...style,
      }}
    >
      {children}
    </span>
  );
}
